<!--second tab-->
<div class="card">
    <div *ngIf="generalGatewayModel?.additionalGateway" class="input-group">
        <label for="withHeating">Heizung einrichten*</label>
        <app-input-on-off
                [(ngModel)]="model.withHeating"
                name="withHeating"
                id="withHeating">
            <span class="on">Ja</span>
            <span class="off">Nein</span>
        </app-input-on-off>
    </div>

    <ng-container *ngIf="model.withHeating">

        <div class="heating-container">
            <div class="input-group">
                <label for="roomLength">Heizungsraum Länge*</label>
                <input class="input"
                       type="number"
                       placeholder="Länge in Meter eingeben"
                       name="roomLength"
                       id="roomLength"
                       required
                       [(ngModel)]="model.heatingRoomLength"
                />
            </div>
            <div class="input-group">
                <label for="roomWidth">Heizungsraum Breite*</label>
                <input class="input"
                       type="number"
                       placeholder="Breite in Meter eingeben"
                       name="roomWidth"
                       id="roomWidth"
                       required
                       [(ngModel)]="model.heatingRoomWidth"
                />
            </div>
            <div class="input-group">
                <label>Heizungsraum Technikschließung funktioniert*</label>
                <div class="radio-wrapper">
                    <div class="radio-line">
                        <input type="radio" [value]="true" id="shutdownPossibleTrue" name="heatingShutdownPossible"
                               required
                               [(ngModel)]="model.heatingShutdownPossible" #heatingShutdownPossible="ngModel">
                        <label class="radio-label" for="shutdownPossibleTrue">Ja</label>
                    </div>
                    <div class="radio-line">
                        <input type="radio" [value]="false" id="shutdownPossibleFalse" name="heatingShutdownPossible"
                               required
                               [(ngModel)]="model.heatingShutdownPossible" #heatingShutdownPossible="ngModel">
                        <label class="radio-label" for="shutdownPossibleFalse">Nein</label>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label>Heizungsraum Platz für Speicher vorhanden*</label>
                <div class="radio-wrapper">
                    <div class="radio-line">
                        <input type="radio" [value]="true" id="spaceAvailableTrue" name="heatingSpaceAvailable"
                               required
                               [(ngModel)]="model.heatingSpaceAvailable" #heatingSpaceAvailable="ngModel">
                        <label class="radio-label" for="spaceAvailableTrue">Ja</label>
                    </div>
                    <div class="radio-line">
                        <input type="radio" [value]="false" id="spaceAvailableFalse" name="heatingSpaceAvailable"
                               required
                               [(ngModel)]="model.heatingSpaceAvailable" #heatingSpaceAvailable="ngModel">
                        <label class="radio-label" for="spaceAvailableFalse">Nein</label>
                    </div>
                </div>
            </div>
        </div>


        <div class="heating-container"
             *ngFor="let heating of model.heatings; let i = index">
            <div class="heating-header" *ngIf="i > 0">
                <div class="icon-button" (click)="removeHeatingByIndex(i)">
                    <i class="juc ju-delete"></i>
                </div>
            </div>
            <div class="input-group">
                <label [for]="'heatingType' + i">{{ i === 0 ? "Hauptheizung" : "Weitere Heizung" }}*</label>
                <select [name]="'heatingType' + i"
                        [id]="'heatingType' + i"
                        required
                        [(ngModel)]="heating.heatingType"
                        (ngModelChange)="checkHeatingsFormat($event)">
                    <option [ngValue]="undefined" disabled>
                        {{ i === 0 ? "Hauptheizung" : "Weitere Heizung" }} auswählen
                    </option>
                    <option [value]="option.value"
                            *ngFor="let option of heatingTypeOptions">
                        {{ option.label }}
                    </option>
                </select>
            </div>

            <div *ngIf="!isSubDistribution()" class="input-group">
                <label [for]="'constructionYear' + i">Baujahr</label>
                <input class="input"
                       type="text"
                       placeholder="Baujahr eingeben"
                       [name]="'constructionYear' + i"
                       [id]="'constructionYear' + i"
                       pattern="[1,2]\d{3}"
                       [(ngModel)]="heating.constructionYear"/>
            </div>

            <ng-container *ngIf="!isSubDistribution()">
                <label class="line-input-label" [for]="'manufacturer' + i">Hersteller*</label>
                <div class="input-group-line">
                    <div class="input-group" *ngIf="isManufacturerSelect[i]" style="width: 100%">

                        <select [name]="'manufacturer' + i"
                                [id]="'manufacturer' + i"
                                required
                                [(ngModel)]="heating.manufacturer">
                            <option [ngValue]="undefined" disabled>Hersteller auswählen</option>
                            <option [value]="option.value" *ngFor="let option of manufacturerTypeOptions">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>

                    <div class="input-group" *ngIf="!isManufacturerSelect[i]" style="width: 100%">
                        <input class="input"
                               type="text"
                               placeholder="Hersteller eingeben"
                               [name]="'manufacturer' + i"
                               [id]="'manufacturer' + i"
                               required
                               [(ngModel)]="heating.manufacturer"/>
                    </div>

                    <div class="input-group">
                        <div class="icon-button">
                            <i class="juc" [ngClass]="isManufacturerSelect[i] ? 'ju-edit' : 'ju-reports'"
                               (click)="changeManufacturerInputType(i)"></i>
                        </div>
                    </div>

                </div>

                <div *ngIf="!isSubDistribution()" class="input-group">
                    <label [for]="'serialNumber' + i">Seriennummer</label>
                    <input class="input"
                           type="text"
                           placeholder="Seriennummer eingeben"
                           [name]="'serialNumber' + i"
                           [id]="'serialNumber' + i"
                           [(ngModel)]="heating.serialNumber"/>
                </div>

                <div *ngIf="!isSubDistribution()" class="input-group">
                    <label [for]="'heatingPower' + i">Leistung in kW</label>
                    <input class="input"
                           type="number"
                           placeholder="Leistung eingeben"
                           [name]="'heatingPower' + i"
                           [id]="'heatingPower' + i"
                           [(ngModel)]="heating.heatingPower"/>
                </div>

                <div class="g_foto-boxes-container">
                    <app-image-input label="Foto Typenschild Heizung*"
                                     [name]="'heatingTypeImage' + i"
                                     required
                                     [imageQuality]="LOW_IMAGE_QUALITY"
                                     [(ngModel)]="heating.heatingTypeImage">
                    </app-image-input>

                    <app-image-input label="Foto Heizungsanlage*"
                                     [name]="'heatingSystemImage' + i"
                                     required
                                     [imageQuality]="LOW_IMAGE_QUALITY"
                                     [(ngModel)]="heating.heatingSystemImage">
                    </app-image-input>
                </div>

                <div class="line"></div>
            </ng-container>

            <div class="input-group"
                 *ngIf="isSettingsBoxVisible(i, model.heatings?.length)">
                <label [for]="'control' + i">Steuerung*</label>
                <select [name]="'control' + i"
                        [id]="'control' + i"
                        required
                        [(ngModel)]="model.heatingControlType">
                    <option [ngValue]="undefined" disabled>Steuerung auswählen</option>
                    <option [value]="ControlEnum.EXTERNAL">Extern</option>
                    <option [value]="ControlEnum.BOILERS">Über Hauptanlage</option>
                </select>
                <app-image-input *ngIf="isSettingsBoxVisible(i, model.heatings?.length)"
                                 label="Foto Steuerung"
                                 [imageQuality]="LOW_IMAGE_QUALITY"
                                 [name]="'heatingControlImage' + i"
                                 [(ngModel)]="model.heatingControlImage">
                </app-image-input>
                <div class="line"></div>
            </div>
        </div>

        <button *ngIf="!isSubDistribution()" (click)="onAddHeatingBtnClicked()" class="secondary">
            <i class="ju ju-add"></i>
            <div>Heizung hinzufügen</div>
        </button>

    </ng-container>
    <!--    <div class="body-input">-->

    <!--        <button *ngIf="canAddUploadField()" (click)="addEmptyUploadField()" fxLayoutAlign="center center">-->
    <!--            <i class="ju ju-add"></i>-->
    <!--            <div>Heizung hinzufügen</div>-->
    <!--        </button>-->
    <!--    </div>-->
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/building'"
        [isNextLinkDisabled]="!validationService.isHeatingInformationValid(model)"
        [nextLink]="'/gateway/heating/check'"
        [isLast]="false"
></app-navigation-footer>
